/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Box, Typography } from '@mui/material';

const ParticipacaoBanner = ({ mode, nsirData, meusDigitados }) => {
  if (mode !== 'CONSULTA') return null;

  const digitadorNome =
    nsirData?.participacaoUsuario?.digitadorAtual?.nome
    || nsirData?.digitadorNome
    || 'outro digitador';

  return (
    <Box sx={{ mb: 2 }}>
      <Alert severity="info" variant="outlined">
        <Typography variant="body2">
          Esta NSIR está com <strong>{digitadorNome}</strong>
          {nsirData?.status ? ` (${nsirData.status.replace(/_/g, ' ')})` : ''}.
        </Typography>
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          Você digitou <strong>{meusDigitados ?? 0}</strong> serviço(s) aqui — visualização
          somente leitura.
        </Typography>
      </Alert>
    </Box>
  );
};

ParticipacaoBanner.propTypes = {
  mode: PropTypes.string,
  nsirData: PropTypes.object,
  meusDigitados: PropTypes.number,
};

ParticipacaoBanner.defaultProps = {
  mode: 'NENHUMA',
  nsirData: {},
  meusDigitados: 0,
};

export default ParticipacaoBanner;
